import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

class MainWrapper extends PureComponent {

  render() {
    let wrapperClass = classNames({
      'wrapper': true,
      'wrapper--full-width': this.props.sidebar.collapse,
      'squared-corner-theme': false,
      'blocks-with-shadow-theme': false,
      'top-navigation': false
    });
    
    const theme = 'theme-retailcompass';
    return (
      <div className={theme}>
        <div className={wrapperClass}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    theme: state.theme,
    sidebar: state.sidebar,
    customizer: state.customizer
  }
})(MainWrapper);